/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Experience_Keywords_PeriodInputs */

const en_experience_keywords_period = /** @type {(inputs: Experience_Keywords_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OCT 2024 – CURRENT`)
};

const ar_experience_keywords_period = /** @type {(inputs: Experience_Keywords_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أكتوبر 2024 – حتى الآن`)
};

const bn_experience_keywords_period = /** @type {(inputs: Experience_Keywords_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`অক্টো ২০২৪ – বর্তমান`)
};

const de_experience_keywords_period = /** @type {(inputs: Experience_Keywords_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OKT 2024 – AKTUELL`)
};

const es_experience_keywords_period = /** @type {(inputs: Experience_Keywords_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OCTUBRE 2024 – ACTUAL`)
};

const fr_experience_keywords_period = /** @type {(inputs: Experience_Keywords_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OCT 2024 – ACTUEL`)
};

const pt_experience_keywords_period = /** @type {(inputs: Experience_Keywords_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OUT 2024 – ATUAL`)
};

const zh_experience_keywords_period = /** @type {(inputs: Experience_Keywords_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2024 年 10 月 – 当前`)
};

const tr_experience_keywords_period = /** @type {(inputs: Experience_Keywords_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EKİM 2024 – GÜNCEL`)
};

const ru_experience_keywords_period = /** @type {(inputs: Experience_Keywords_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ОКТЯБРЬ 2024 ГОДА – СЕЙЧАС`)
};

const pl_experience_keywords_period = /** @type {(inputs: Experience_Keywords_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PAŹDZIERNIK 2024 – AKTUALNY`)
};

/**
* | output |
* | --- |
* | "OCT 2024 – CURRENT" |
*
* @param {Experience_Keywords_PeriodInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const experience_keywords_period = /** @type {((inputs?: Experience_Keywords_PeriodInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Experience_Keywords_PeriodInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_experience_keywords_period(inputs)
	if (locale === "bn") return bn_experience_keywords_period(inputs)
	if (locale === "de") return de_experience_keywords_period(inputs)
	if (locale === "es") return es_experience_keywords_period(inputs)
	if (locale === "fr") return fr_experience_keywords_period(inputs)
	if (locale === "pt") return pt_experience_keywords_period(inputs)
	if (locale === "zh") return zh_experience_keywords_period(inputs)
	if (locale === "tr") return tr_experience_keywords_period(inputs)
	if (locale === "ru") return ru_experience_keywords_period(inputs)
	if (locale === "pl") return pl_experience_keywords_period(inputs)
	return en_experience_keywords_period(inputs)
});